import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectDetailPhaseGridPage } from './project-detail-phase-grid';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { PtKendoModule } from '../../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    ProjectDetailPhaseGridPage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectDetailPhaseGridPage),
    GridModule,
    SharedModule,
    BodyModule,
    PtKendoModule
  ],
})
export class ProjectDetailPhaseGridPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-phase-grid/project-detail-phase-grid.module.ts